<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('sowing.reason_rejection')}.pdf`,
        route: `${getModuleRoute}/pdf`,
        paramMethod: 'POST',
        plusData: { exportType: rejectionType },
      },
      xls: {
        filename: `${$t('sowing.reason_rejection')}.xlsx`,
        route: `${getModuleRoute}/excel`,
        paramMethod: 'POST',
        plusData: { exportType: rejectionType },
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.crops'),
        data: 'crops',
        property: 'name',
        minWidth: 110,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tablePropertiesByRejectionType"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-reason-rejection
        v-if="renderComponent"
        :syncDialog="modals"
        :rejectionType="rejectionType"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getUrlMasterModule } from 'src/util/Util';
import EditCreate from 'src/views/Pages/Dashboard/Nursery/ReasonRejection/EditCreate.vue';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import ReasonRejectionTable from './reason-rejection-table';

export default {
  name: 'reason-rejection',
  props: {
    rejectionType: {
      type: String,
      default: 'Vivero',
    },
  },
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinForm,
    MixinLoading,
    MixinMain,
    MixinMenu,
    MixinPermissions,
    MixinRerender,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'nursery/reasonrejection';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ReasonRejectionTable().tableColumns],
        model: 'reasonrejection',
        effectTags: 'dark',
        widthColumnStatus: 160,
        widthOperations: 110,
        defaultSort: { prop: 'code', order: 'ascending' },
        addColumns: [
          {
            data: 'crops',
            label: i18n.t('common_words.crops'),
            field: 'name',
          },
        ],
      };
    },
    tablePropertiesByRejectionType() {
      if (!this.tableProperties.data) return this.tableProperties;

      const clonedTableProperties = { ...this.tableProperties };
      if (getUrlMasterModule() == 'pruning') {
        clonedTableProperties.data = clonedTableProperties.data.filter(
          (item) => {
            return item.type === 'Poda';
          }
        );
      } else if (getUrlMasterModule() == 'nursery') {
        clonedTableProperties.data = clonedTableProperties.data.filter(
          (item) => {
            return item.type === 'Vivero';
          }
        );
      }

      return clonedTableProperties;
    },
  },
};
</script>
